require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-video-el-metropolitano-de-lima-cinco-anos-luchando-por-su-accesibilidad.json") })
        }
      }, "path---es-mx-update-video-el-metropolitano-de-lima-cinco-anos-luchando-por-su-accesibilidad");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-video-el-metropolitano-de-lima-cinco-anos-luchando-por-su-accesibilidad!./.cache/json/es-mx-update-video-el-metropolitano-de-lima-cinco-anos-luchando-por-su-accesibilidad.json
// module id = 937
// module chunks = 231608221292675